<template>
    <div :id="id" class="custom-drop">
        <div :class="['custom-drop-wrapper',additional_classes]" @click="openDrop">
            <div class="custom-drop-chosen" >
                <span>{{drop_items.find(i=>i.id == selected_id) ? drop_items.find(i=>i.id == selected_id).naziv : init_text != undefined ? init_text : 'Odaberite stavku' }}</span>
                <div v-if="custom_icon" class="custom-drop-icon"></div>
                <svg class="d-arrow" xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none">
                    <path d="M1 1L7 7L13 1" stroke="#3326AE" stroke-width="2" stroke-miterlimit="20"/>
                </svg>            
            </div>
        </div>
        <div :class="['custom-drop-item-list']">
            <div v-for="(i, key) in drop_items" :key="key" @click="selectItem(i.id)" :class="['custom-drop-item', i.id == selected_id ? 'active' : '']"><span>{{i.naziv}}</span></div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'

export default {
    props:['id', 'selected_id', 'drop_items', 'init_text','additional_classes', 'custom_icon'],
    data() {
        return {
        }
    },
    model:{
        prop: 'selected_id',
        event: 'click'
    },
    methods:{
        openDrop(){
            $(`#${this.id}`).toggleClass('active')
            $(`#${this.id} .custom-drop-item.active`)[0].scrollIntoView({block:'center'});
        },
        selectItem(val){
            $(`#${this.id}`).removeClass('active')
            this.$emit('click', val);
        }
    },
    mounted() {
        setTimeout(() => {
            let _this = this;
            $('.v-application--wrap').click(function (e) {
                var container = $(`#${_this.id}`)
                if(!container.is(e.target) && container.has(e.target).length === 0) {
                    $(`#${_this.id}`).removeClass('active')
                }
            });
        }, 1000);
    },
    beforeDestroy() {
        $('.v-application--wrap').off();
    },
}
</script>